// SocialIcons.js
import "./SocialIcons.css";
import facebook from "../../images/facebook.svg";
import whatsapp from "../../images/whatsapp.svg";
import mail from "../../images/mail.svg";
import { ReactSVG } from "react-svg";

const SocialIcons = () => {
  return (
    <div className="social-icons">
      <a
        href="mailto:info@dotmedica.com"
        rel="noopener noreferrer"
        className="icon"
      >
        <ReactSVG src={mail} />
      </a>
      <a
        href="https://wa.me/201202137077"
        className="icon"
      >
        <ReactSVG src={whatsapp} />
      </a>
      <a
        href="https://www.facebook.com/dotmedica"
        rel="noopener noreferrer"
        className="icon"
      >
        <ReactSVG src={facebook} />
      </a>
    </div>
  );
};

export default SocialIcons;
